import { ExternalApiQueryMpiPortfolio } from './ExternalApiQueryMpiPortfolio';
import { BaseQuery } from '../../../BaseQuery';
import { ProviderBase } from '../ProviderBase';
import { TranslationHelper } from '../../../../helpers';
import { IQueryOptions } from '../../../../models/query';

export class MpiProvider extends ProviderBase {
	getQuery = (queryOptions: IQueryOptions, translationHelper?: TranslationHelper) => {
		let query: BaseQuery | undefined;
		const { name } = this.request;
		if (name === 'portfolio') {
			query = new ExternalApiQueryMpiPortfolio(queryOptions, translationHelper);
		}
		return query;
	};
}
